import type { Configuration } from 'modules/integrations/hooks/SyncContext'

export const EXPENSES_SYNC_CONFIGURATION: Configuration = {
  origin: 'expenses',
}
